/* BareLow — collection grid: per-card photo scroller (one photo per scroll/swipe), sort select. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  let lastPageScroll = 0;
  window.addEventListener('scroll', () => { lastPageScroll = Date.now(); }, { passive: true });

  const init = (box) => {
    if (box.dataset.ready) return; box.dataset.ready = 1;
    const tr = $('[data-bfg-track]', box), dots = $$('.bfg-dots i', box), prev = $('[data-bfg-prev]', box), next = $('[data-bfg-next]', box);
    const n = tr.children.length;
    const cur = () => Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
    const paint = () => { const c = cur(); dots.forEach((d, i) => d.classList.toggle('is-on', i === c)); if (prev) prev.disabled = c <= 0; if (next) next.disabled = c >= n - 1; };
    const go = (i) => { i = Math.max(0, Math.min(n - 1, i)); tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' }); };
    tr.addEventListener('scroll', () => requestAnimationFrame(paint), { passive: true });
    if (prev) prev.addEventListener('click', (e) => { e.preventDefault(); go(cur() - 1); });
    if (next) next.addEventListener('click', (e) => { e.preventDefault(); go(cur() + 1); });
    /* mouse wheel / trackpad: one photo per scroll. Vertical wheel only after the pointer rests on the photo. */
    let armed = false, armT, gest = false, idle, acc = 0, lastStep = 0;
    const arm = (on) => { armed = on; box.classList.toggle('is-armed', on); };
    const tryArm = (e) => { if (e.pointerType && e.pointerType !== 'mouse') return; clearTimeout(armT); if (!armed) armT = setTimeout(() => { if (Date.now() - lastPageScroll > 350) arm(true); }, 450); };
    box.addEventListener('pointerenter', tryArm);
    box.addEventListener('pointermove', tryArm);
    box.addEventListener('pointerleave', () => { clearTimeout(armT); arm(false); });
    box.addEventListener('wheel', (e) => {
      const horiz = Math.abs(e.deltaX) > Math.abs(e.deltaY) * 1.2;
      const d = horiz ? e.deltaX : e.deltaY, c = cur();
      if (!horiz) {
        if (!armed || Date.now() - lastPageScroll < 350) { clearTimeout(armT); arm(false); return; }
        if (!gest && ((d > 0 && c >= n - 1) || (d < 0 && c <= 0))) return; /* at the ends the page scrolls on */
      }
      e.preventDefault();
      const now = performance.now();
      clearTimeout(idle); idle = setTimeout(() => { gest = false; acc = 0; }, 220);
      const notch = e.deltaMode === 1 || Math.abs(d) >= 50;
      if (notch) { if (now - lastStep > 250) { go(c + (d > 0 ? 1 : -1)); lastStep = now; } gest = true; return; }
      if (gest) return;
      acc += d;
      if (Math.abs(acc) >= 30) { go(c + (acc > 0 ? 1 : -1)); lastStep = now; gest = true; acc = 0; }
    }, { passive: false });
    /* a drag with the mouse should not open the product */
    let sx = 0, dragged = false;
    tr.addEventListener('pointerdown', (e) => { sx = e.clientX; dragged = false; });
    tr.addEventListener('pointermove', (e) => { if (e.buttons === 1 && Math.abs(e.clientX - sx) > 8) dragged = true; });
    tr.addEventListener('click', (e) => { if (dragged) { e.preventDefault(); dragged = false; } }, true);
    paint();
  };
  const all = () => $$('[data-bfg-multi]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();

  $$('[data-bfg-sort]').forEach((s) => s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString(); }));
})();
